import { render, staticRenderFns } from "./BasePaginator.vue?vue&type=template&id=8e03a6a8&"
import script from "./BasePaginator.vue?vue&type=script&lang=js&"
export * from "./BasePaginator.vue?vue&type=script&lang=js&"
import style0 from "./BasePaginator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports